import { tryCatchHelper } from '../../helpers';
import {
  GETALL_ENT_DESTACADAS,
  LOADING_GETALL_ENT_DESTACADAS,
  SET_ACTIVO_ENT_DESTACADAS,
} from '../../store/Types';
import {
  deleteEntDestacadasService,
  getAllEntDestacadasService,
  saveEntDestacadasService,
} from './EntDestacadasService';

export const getAllEntDestacadasAction = async (dispatch, params) => {
  try {
    dispatch({
      type: LOADING_GETALL_ENT_DESTACADAS,
      payload: true,
    });
    const res = await getAllEntDestacadasService(params);
    dispatch({
      type: GETALL_ENT_DESTACADAS,
      payload: res.data,
    });
    dispatch({
      type: LOADING_GETALL_ENT_DESTACADAS,
      payload: false,
    });
    return res.data;
  } catch (e) {
    dispatch({
      type: LOADING_GETALL_ENT_DESTACADAS,
      payload: false,
    });
    tryCatchHelper(e);
    return false;
  }
};

export const saveEntDestacadasAction = async (
  { dispatch, addNotification },
  id,
  data,
  params
) => {
  try {
    let res = await saveEntDestacadasService(id, data, params);
    addNotification(
      res.data.message ?? id
        ? 'EntDestacada actualizado.'
        : 'EntDestacada registrado.'
    );
    await getAllEntDestacadasAction(dispatch, params);
    setActivoEntDestacadasAction(dispatch, null);
    return res;
  } catch (e) {
    tryCatchHelper({ e, addNotification });
    return false;
  }
};

export const setActivoEntDestacadasAction = async (dispatch, data) => {
  dispatch({
    type: SET_ACTIVO_ENT_DESTACADAS,
    payload: data,
  });
};

export const deleteEntDestacadasAction = async ({ dispatch, addNotification }, id) => {
  try {
    let res = await deleteEntDestacadasService(id);
    addNotification(res.data.message ?? 'EntDestacada eliminado.');
    await getAllEntDestacadasAction(dispatch);
  } catch (e) {
    tryCatchHelper({ e, addNotification });
    return false;
  }
};
